import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Phone, Mail } from 'lucide-react';
import SEO from '../components/SEO';

const SellPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="Vendre votre bien | Estimation personnalisée - Pam Immobilier"
        description="Vous souhaitez vendre votre maison ou appartement ? Bénéficiez d'une estimation personnalisée sans engagement. Pam Immobilier vous accompagne."
      />
      <Header />
      <main>
        {/* Hero Section - Clean gradient banner */}
        <section className="relative bg-gradient-to-br from-[#8B2942] via-[#A13350] to-[#722338] overflow-hidden mt-32" style={{ height: '120px' }}>
          <div className="absolute inset-0 flex items-center z-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
              <h1 className="text-2xl md:text-3xl font-bold text-white">
                Vendre votre bien
              </h1>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Intro */}
            <div className="text-center mb-12">
              <p className="text-2xl md:text-3xl font-bold text-[#8B2942] mb-8">
                Chaque bien mérite une attention particulière.
              </p>
            </div>

            {/* Main Content */}
            <div className="prose prose-lg max-w-none space-y-6 text-slate-600 leading-relaxed mb-12">
              <p>
                Vendre un bien immobilier est une étape importante. Pam Immobilier vous accompagne de l'estimation jusqu'à la signature chez le notaire afin de vous permettre de vendre dans les meilleures conditions.
              </p>
              <p>
                Une estimation sérieuse nécessite une visite du bien et une analyse du marché local. Elle est offerte dans le cadre d'un mandat de vente.
              </p>
              <p>
                Chez PAM, votre bien bénéficie d'une large visibilité, grâce à mon réseau interprofessionnel et à une diffusion ciblée sur les principales plateformes actives en Suisse romande.
              </p>
            </div>

            {/* Call to Action */}
            <div className="bg-gradient-to-br from-slate-50 to-white p-8 md:p-12 rounded-2xl text-center">
              <h2 className="text-2xl font-bold text-[#8B2942] mb-4">
                Prêt à vendre votre bien ?
              </h2>
              <p className="text-slate-600 mb-8">
                Contactez-moi pour une estimation personnalisée et sans engagement.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button asChild size="lg" className="bg-[#8B2942] hover:bg-[#6d2033]">
                  <a href="tel:+41791337898" className="flex items-center gap-2">
                    <Phone className="w-5 h-5" />
                    Me contacter : 079 133 78 98
                  </a>
                </Button>
                <Button asChild size="lg" variant="outline" className="border-[#8B2942] text-[#8B2942] hover:bg-[#8B2942] hover:text-white">
                  <Link to="/contact" className="flex items-center gap-2">
                    <Mail className="w-5 h-5" />
                    Envoyer un message
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default SellPage;
